import LoanAccountCredit from "./LoanAccountCredit";

export default LoanAccountCredit;